<template>
  <v-container fluid grid-list-xl pt-0>
    <v-layout wrap>
      <v-flex xs12>
        <material-card
          class="card-shrink card-padding v-card__first"
          color="general"
          title="Performance 熱測資料搜尋"
        >
          <v-form>
            <v-container py-0 class="mw-100">
              <v-layout wrap>
                <v-flex xs12 sm6 lg3>
                  <v-autocomplete
                    v-model="summaryProcessType"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="[
                      { text: 'HP', value: 'HP' },
                      { text: 'VC', value: 'VC' }
                    ]"
                    label="製程別"
                    outlined
                  />
                </v-flex>
                <v-flex xs12 sm6 lg5>
                  <v-text-field
                    v-model="summaryBarcode"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label="Barcode"
                  />
                </v-flex>
                <v-flex xs12 lg4 text-xs-right>
                  <v-btn class="mx-0 font-weight-light" color="general" @click="doSubmit()">
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>查詢
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>

        <material-card>
          <v-data-table
            :headers="headers"
            :items="responseDataTable"
            :pagination.sync="pagination"
            multi-sort
            hide-actions
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="subheading font-weight-light text-general text--darken-3" v-text="header.text"/>
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.barcode }}</td>
              <td class="text-xs-right">{{ item.dt1 }}</td>
              <td class="text-xs-right">{{ item.dt2 }}</td>
              <td class="text-xs-right">{{ item.t1 }}</td>
              <td class="text-xs-right">{{ item.t2 }}</td>
              <td class="text-xs-right">{{ item.t3 }}</td>
              <td class="text-xs-right">{{ item.t4 }}</td>
              <td class="text-xs-right">{{ item.roomTemperature }}</td>
              <td>{{ item.testResult }}</td>
              <td>{{ item.traceDate }} {{ item.traceTime }}</td>
              <td>
                <router-link
                  :to="'/ctqThermalPerformance/singleTestDataInfo/' + item.pk + '?processType=' + (item.processType || summaryProcessType)"
                  target="_blank"
                >
                  <v-btn class="mx-0 mr-3 font-weight-light small" color="green">
                    <v-icon class="mr-2">mdi-clipboard-text-outline</v-icon>資料檢視
                  </v-btn>
                </router-link>
                <router-link
                  :to="'/ctqThermalPerformance/testDataStatistc?deviceIsn='+item.deviceIsn+'&modelname='+item.modelName+'&date='+item.traceDate+'&vendorpk='+item.vendorPk+'&vendor='+item.vendor+'&processType='+item.processType"
                  target="_blank"
                >
                  <v-btn class="mx-0 font-weight-light small" color="primary">
                    <v-icon class="mr-2">mdi-chart-bar</v-icon>當日統計
                  </v-btn>
                </router-link>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snackbar" :top="true" :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CTQThermalPerformanceSearch',
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      summaryBarcode: '',
      summaryProcessType: 'HP',
      responseDataTable: [],
      pagination: { rowsPerPage: 25, sortBy: 'traceDate', descending: true },
      headers: [
        { text: 'Barcode', value: 'barcode' },
        { text: 'DT1', value: 'dt1', align: 'right' },
        { text: 'DT2', value: 'dt2', align: 'right' },
        { text: 'T1', value: 't1', align: 'right' },
        { text: 'T2', value: 't2', align: 'right' },
        { text: 'T3', value: 't3', align: 'right' },
        { text: 'T4', value: 't4', align: 'right' },
        { text: '室溫', value: 'roomTemperature', align: 'right' },
        { text: '結果', value: 'testResult' },
        { text: '測試時間', value: 'traceDate' },
        { text: '操作', value: '' }
      ]
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink'])
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/ctqThermalPerformance/testDataInfoSearch')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          if (this.$route.params.searchBarcode) {
            this.summaryBarcode = this.$route.params.searchBarcode
            this.doSubmit()
          }
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    doSubmit () {
      if (!this.summaryBarcode) {
        this.snackbar = true
        this.snackbarColor = 'orange'
        this.snackbarMsg = '請輸入 Barcode'
        return
      }
      this.$http.post('/api/ctqThermalPerformance/singleDeviceData?barcode=' + this.summaryBarcode + '&processType=' + (this.summaryProcessType || 'HP')).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.responseDataTable = res.data
          } else {
            this.responseDataTable = []
            this.snackbar = true
            this.snackbarColor = 'orange'
            this.snackbarMsg = res.errMsg || '查無資料'
          }
        })
    }
  }
}
</script>
